import type {
  UNREAD,
  READ,
  UNANSWERED,
  ANSWERED,
  WHATSAPP,
  INSTAGRAM,
  VK,
} from '@app/constants';

export namespace NMessage {
  export type ModelMessageSearchResult = {
    Id: number;
    Items: ModelClientMessage[] | null;
    PageN: number;
    CountPages: number;
    CountItems: number;
  };

  export type ModelClientMessage = {
    Id: number;
    Timestamp: string;
    Direction: 'in' | 'out' | null;
    ChannelName: string | null;
    IntegrationId: number | null;
    IntegrationName: string | null;
    ClientId: number;
    ClientName: string | null;
    UserId: number | null;
    UserName: string | null;
    Message: string | null;
    Status: string | null;
  };

  export type StatusId =
    | typeof UNREAD
    | typeof READ
    | typeof UNANSWERED
    | typeof ANSWERED;

  export type ChannelId = typeof WHATSAPP | typeof INSTAGRAM | typeof VK;
}
